import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from '../contexts/TranslationContext';

const Plans: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="plans">
      <Helmet>
        <title>Plans & Pricing | PhilipSnat</title>
        <meta name="description" content="Choose a plan to unlock premium sports betting picks from verified expert tipsters on PhilipSnat." />
        <meta property="og:title" content="Plans & Pricing | PhilipSnat" />
        <meta property="og:description" content="Choose a plan to unlock premium sports betting picks from verified expert tipsters on PhilipSnat." />
        <meta property="og:url" content="https://philipsnat.com/plans" />
        <link rel="canonical" href="https://philipsnat.com/plans" />
      </Helmet>
      <h1>{t.pages.plansTitle}</h1>
      <p>{t.pages.plansDescription}</p>
    </div>
  );
};

export default Plans;
